import { fetchApi } from '@/services/api-client';

export const ROOMS_PATH = '/admin/rooms';

export type Room = {
  id: string;
  name: string;
  code: string | null;
  sortOrder: number;
  active: boolean;
  bookable: boolean;
  createdAt: string;
  updatedAt: string;
};

export const roomsApi = {
  list: () => fetchApi<Room[]>(ROOMS_PATH),
  getById: (id: string) => fetchApi<Room>(`${ROOMS_PATH}/${id}`),
  create: (data: { name: string; code?: string; sortOrder?: number; active?: boolean; bookable?: boolean }) =>
    fetchApi<Room>(ROOMS_PATH, { method: 'POST', body: JSON.stringify(data) }),
  update: (
    id: string,
    data: { name?: string; code?: string | null; sortOrder?: number; active?: boolean; bookable?: boolean }
  ) => fetchApi<Room>(`${ROOMS_PATH}/${id}`, { method: 'PATCH', body: JSON.stringify(data) }),
  delete: (id: string) => fetchApi<{ success: boolean }>(`${ROOMS_PATH}/${id}`, { method: 'DELETE' }),
};
